import { render, staticRenderFns } from "./NotAvailable.vue?vue&type=template&id=8867f07e&scoped=true&"
import script from "./NotAvailable.vue?vue&type=script&lang=js&"
export * from "./NotAvailable.vue?vue&type=script&lang=js&"
import style0 from "./NotAvailable.vue?vue&type=style&index=0&id=8867f07e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8867f07e",
  null
  
)

export default component.exports